module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Screwdriver-9e95114abf31bac29a71dd08f8a5804f.svg";